import * as React from "react";
import { forwardRef } from "react";
const SvgPanelGroupOpenClose = ({
  title,
  titleId,
  ...props
}, ref) => <svg width={21} height={21} viewBox="0 0 21 21" xmlns="http://www.w3.org/2000/svg" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<g fill="none" fillRule="evenodd"><path d="M0 0h21v21H0z" /><path fill="#FFF" d="m13.837 11-6 4.837V6.163z" /></g></svg>;
const ForwardRef = forwardRef(SvgPanelGroupOpenClose);
export { ForwardRef as ReactComponent };